import {
  RECORD_GET_LIST_ACTION,
  RECORD_SAVE_ACTION,
  RECORD_SHOW_ACTION,
  RECORD_DELETE_ACTION,
  RECORD_APPROVE_ACTION,
  RECORD_DENY_ACTION
} from '../constants/record'

// Initial state
const initialState = {
  list: {
    data: [],
    current_page: 1,
    per_page: 10,
    total: 0
  },
  reload: false,
  record: null,
  error: false
}

const recordReducer = (state = initialState, action) => {
  switch (action.type) {
    case RECORD_GET_LIST_ACTION:
      return {
        ...state,
        list: action.payload.list,
        error: false,
        reload: false
      }
    case RECORD_SAVE_ACTION:
      return {
        ...state,
        record: action.payload,
        reload: true,
        error: false
      }
    case RECORD_SHOW_ACTION:
      return {
        ...state,
        record: action.payload,
        error: false
      }
    case RECORD_DELETE_ACTION:
      return {
        ...state,
        reload: true,
        error: false
      }
    case RECORD_APPROVE_ACTION:
      return {
        ...state,
        record: action.payload,
        reload: true,
        error: false
      }
    case RECORD_DENY_ACTION:
      return {
        ...state,
        record: action.payload,
        reload: true,
        error: false
      }
    default:
      return state
  }
}

export default recordReducer
